module.exports = __webpack_public_path__ + "media/images/application/default/default-transport-063cb36813ffbe72280bc095848d4144.jpg";